<template>
  <vs-dropdown vs-trigger-click class="cursor-pointer">

    <div class="flex items-center" v-if="isAuth">
      <div class="text-right hidden sm:block">
        <p class="font-semibold">{{ authUser.name }}</p>
        <p class="text-xs">{{ authUser.email }}</p>
      </div>
      <vs-avatar :src="authUser.profile_image_url" :text="authUser.name"/>
    </div>

    <vs-dropdown-menu class="vx-navbar-dropdown">
      <vs-dropdown-item :to="{name: 'settings'}" class="transition-none">
        <div class="flex">
          <feather-icon icon="SettingsIcon" svgClasses="w-4 h-4"/>
          <span class="ml-2">Настройки</span>
        </div>
      </vs-dropdown-item>

      <vs-dropdown-item @click.prevent="logout" class="transition-none">
        <div class="flex">
          <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4"/>
          <span class="ml-2">Выйти</span>
        </div>
      </vs-dropdown-item>

    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import {mapGetters} from 'vuex'
import Auth from '../../../../api/http/models/auth/Auth'

export default {
  computed: {
    ...mapGetters(['authUser', 'isAuth'])
  },
  methods: {
    async logout () {
      const response = await Auth.logout()
      if (response.status === 'success') {
        document.location = '/'
      }
    }
  }
}
</script>
